export * from './groupedsensor.module';
export * from './groupedsensor.component';
